<template>
    <div class="text-center">
        <v-dialog
            v-model="loadDialog"
            max-width="400"
        >
          <v-form @submit.prevent="onSignIn">
            <app-alert @dismissed="onDismissed" :text="error.message" v-if="error"></app-alert>
            <v-card>
              <v-card-title>
                  <v-col class="text-center" >
                      <h2 :style="`color:${color}`">Inicia sesión</h2>
                  </v-col>
              </v-card-title>
              <v-divider></v-divider>
              <v-card-text>
                <v-row >
                    <v-col cols="12">
                        <v-text-field
                            name="email"
                            label="Email"
                            id="sign-in-email"
                            v-model="email"
                            type="email"
                            required>
                        </v-text-field>
                    </v-col>
                </v-row>
                <v-row >
                    <v-col cols="12">
                        <v-text-field
                            name="password"
                            id="sign-in-password"
                            v-model="password"
                            type="password"
                            label="Password"
                            required>
                        </v-text-field>
                    </v-col>
                </v-row>
              </v-card-text>
              <v-card-actions>
                <v-col class="text-center" >
                  <v-btn
                    :color="color"
                    text
                    :disabled="loading"
                    @click="closeDialog"
                  >
                    Cancelar
                  </v-btn>
                  <v-btn
                    type="submit"
                    :disabled="loading"
                    :loading="loading"
                    :color="color"
                    :dark="!loading"
                  >
                    Iniciar sesión
                  </v-btn>
                </v-col>
              </v-card-actions>
            </v-card>
          </v-form>
        </v-dialog>
    </div>
</template>
<script>
/* eslint-disable no-console */
import * as constants from '../../../constants.json'

export default {
  props: ['showSignInDialog'],

  data () {
    return {
      email: '',
      password: '',
      confirmPassword: '',
      color: constants.MAINCOLOR,
      style: {
        border: '1px solid #e1e1e1',
        fontColor: '#525252'
      }
    }
  },

  computed: {
    loadDialog () {
      return this.$store.getters.getOpenSignInDialog
    },
    user () {
      return this.$store.getters.getUser
    },
    error () {
      return this.$store.getters.getError
    },
    loading () {
      return this.$store.getters.getLoading
    }
  },

  // // If user is authenticated we load the home page
  // watch: {
  //   user (value) {
  //     if (value !== null && value !== undefined) {
  //       this.showSignInDialog.show = false
  //     }
  //   }
  // },

  methods: {
    // Sending the user credential to store action 'actionSignUserIn' to be processed
    async onSignIn () {
      this.$store.dispatch('actionSignUserInEmail', { email: this.email, password: this.password })
    },

    closeDialog () {
      this.$store.commit('mutationOpenSignInDialog', false)
    },

    // Dismissing alert
    onDismissed () {
      console.log('Dismissed Alert')
      this.$store.dispatch('actionClearError')
    }
  }
}
</script>
